<template>
  <div class="SubscriptionConfirmation SubscriptionCancel">
    <transition name="fade" mode="out-in">
      <app-loading
        class="fullscreen"
        v-if="isLoading"
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>
    <template v-if="!isLoading">
      <header-banner
        :img-src-mobile="subscriptionDetails.headerImageUrlOfMobile"
        :img-src-desktop="subscriptionDetails.headerImageUrlOfDesktop" />

      <div class="container">
        <div class="SubscriptionConfirmation_top" >
          <router-link to="/my-account" class="BackToAccountView">
            ‹ {{ $t('common.breadcrumbNav.accountOverview', 'Account overview') }}
          </router-link>
          <product
            :name="subscriptionDetails.title"
            :image="subscriptionDetails.imageUrl"
            :end-date="subscriptionDetails.endDate"
            :status-pend="subscriptionDetails.status"
          />
        </div>
        <div class="SubscriptionConfirmation_body" >
          <h3 class="title">{{ $t('subscription_cancel.title', 'Sad to see you go') }}</h3>
          <p class="tips">
            {{ $t('subscription_cancel.descriptionOne', 'We will be in touch to inform you on how to return your product. Your cancellation will be effective when we receive your device.') }}
          </p>
          <p class="tips">
            {{ $t('subscription_cancel.descriptionTwo', 'We strive for the highest quality products that match your needs. You might want to find out more about our other products.') }}
          </p>
          <router-link
            to="/"
            class="AppButton"
            @click.native="trackConversion({ name: 'interaction', description: 'find_other_products' })"
          >
            {{ $t('subscription_cancel.button', 'Find other hair removal products') }}
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import SubscriptionPageMixin from 'mixins/subscription-page'

  export default {
    name: 'subscription-cancel',

    mixins: [SubscriptionPageMixin]
  }
</script>

<style lang="scss">
  .SubscriptionCancel {
    .SubscriptionConfirmation_body {
      .tips {
        margin-bottom: .25rem;

        &:last-of-type {
          margin-bottom: .35rem;
        }

        @include media(tablet) {
          font-size: .17rem;
        }
      }
    }
  }
</style>
